var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "support"
    },
    [
      _c(
        "div",
        {
          staticClass: "support__icon",
          class: { "support__icon--active": _vm.click },
          on: { click: _vm.displayForm }
        },
        [
          _c("i", {
            staticClass: "fa fa-question-circle-o",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "support__form" }, [
        _c("div", { staticClass: "support__header" }, [
          _c("span", { staticClass: "support__title" }, [_vm._v("Soporte")]),
          _vm._v(" "),
          _c("div", { staticClass: "support__controls" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: { click: _vm.displayForm }
              },
              [_c("span", [_vm._v("×")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.asunto,
              expression: "form.asunto"
            }
          ],
          staticClass: "support__field subject",
          attrs: { type: "text", placeholder: "Asunto" },
          domProps: { value: _vm.form.asunto },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "asunto", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.mensaje,
              expression: "form.mensaje"
            }
          ],
          staticClass: "support__field message",
          attrs: { name: "message", placeholder: "Mensaje" },
          domProps: { value: _vm.form.mensaje },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "mensaje", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-secondary support__sendbutton",
            attrs: { type: "button" },
            on: { click: _vm.guardarSoporte }
          },
          [_vm._v("Enviar")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3988cabe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3988cabe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/Support.vue
// module id = 296
// module chunks = 0